import { TextButton } from '@twistopayments/design-system/components/atoms/button'

import type { BlocksImageBoxComponent } from '@twisto/api-cms'

import { StrapiMedia } from '../../atoms'

import * as styles from './image-box-slider.styles'

export const ImageBox = ({ src, cta }: BlocksImageBoxComponent) => (
  <div css={styles.imageBox}>
    <StrapiMedia {...src} />
    <div css={styles.cta}>
      {cta
        ?.filter((btn) => btn.text && btn.link)
        .map((button, index) => (
          <TextButton
            key={button.id}
            color={index === cta.length - 1 ? 'secondary' : 'primary'}
            href={button.link}
          >
            {button.text}
          </TextButton>
        ))}
    </div>
  </div>
)
